import React from "react";
import ReactSelect from "react-select";
import { COLORS } from "../../../constants";
import FormActions from "../../../components/Form/FormActions";

interface TamanhosFormProps {
  nome: string;
  lojaId: number;
  lojas: Array<{ id: number; nome: string }>;
  isSaving: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
  onNomeChange: (nome: string) => void;
  onLojaChange: (lojaId: number) => void;
}

const TamanhosForm: React.FC<TamanhosFormProps> = ({
  nome,
  lojaId,
  lojas,
  isSaving,
  onSubmit,
  onCancel,
  onNomeChange,
  onLojaChange,
}) => {
  const lojaOptions = lojas.map((loja) => ({
    value: loja.id,
    label: loja.nome,
  }));

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Loja
        </label>
        <ReactSelect
          options={lojaOptions}
          placeholder="Selecione uma loja"
          isClearable
          value={lojaOptions.find((option) => option.value === lojaId) || null}
          onChange={(option) => onLojaChange(option?.value || 0)}
          styles={{
            control: (base) => ({
              ...base,
              borderColor: COLORS.NEUTRAL_300,
              "&:hover": {
                borderColor: COLORS.PRIMARY,
              },
              "&:focus-within": {
                borderColor: COLORS.PRIMARY,
                boxShadow: "0 0 0 2px rgba(147, 32, 24, 0.2)",
              },
            }),
          }}
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium text-neutral-700">
          Nome do tamanho
        </label>
        <input
          type="text"
          value={nome}
          onChange={(event) => onNomeChange(event.target.value)}
          className="w-full rounded-md border border-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="Ex: Grande"
        />
      </div>

      <FormActions onCancel={onCancel} isLoading={isSaving} />
    </form>
  );
};

export default TamanhosForm;
